// src/context/ContentProvider.js
import React, { createContext, useState, useEffect } from "react";

export const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  // Default values
  const defaultContent = {
    activitiesText: "",
    activitiesStyle: {
      color: "#000000",
      bold: false,
      italic: false,
    },
  };

  const apiUrl = process.env.REACT_APP_API_URL; // "http://localhost:5000"

  // Fetch content from the back‑end when the provider mounts.
  useEffect(() => {
    fetch(`${apiUrl}/api/content`)
      .then((res) => res.json())
      .then((data) => {
        // If data exists, update state.
        if (data && data.activitiesText) {
          setContent(data);
        }
      })
      .catch((err) => console.error("Error fetching content:", err));
  }, [apiUrl]);

  // Load initial state from localStorage if available
  const storedContent = localStorage.getItem("content");
  const initialContent = storedContent ? JSON.parse(storedContent) : defaultContent;

  const [content, setContent] = useState(initialContent);

  // Save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem("content", JSON.stringify(content));
  }, [content]);

  return (
    <ContentContext.Provider value={{ content, setContent }}>
      {children}
    </ContentContext.Provider>
  );
};